import { render, staticRenderFns } from "./TemplateCardBasic.vue?vue&type=template&id=4dc4bbbe&scoped=true&"
import script from "./TemplateCardBasic.vue?vue&type=script&lang=js&"
export * from "./TemplateCardBasic.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCardBasic.vue?vue&type=style&index=0&id=4dc4bbbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc4bbbe",
  null
  
)

export default component.exports